export default function cleanUrlParams(arrayOfParams: string[]) {
  const urlParams = new URLSearchParams(window.location.search);
  arrayOfParams.forEach((param) => {
    urlParams.delete(param);
  });
  window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
}
